
<h2 class="mt-3 ml-5">Predict Result</h2>
<hr>

<div class="main" *ngIf="predictJsonObject | async as resp">
	<!-- Bu kısımda bir container-div kullanarak içerisinde ana görselimiz ve üzerine de bordersları döngü ile çizdiriyoruz -->
	<!-- img elementi css tarafında manuel olarak 650px olarak ayarlandı. Hasan abi böyle olmasını istedi. -->

	<div class="container-div">
		<!--fotoğraf alanı-->
		<ng-container *ngIf="imageUrl | async as photo">
			<img id="photo" #myImage [src]="photo" (load)="getImageSize(myImage)" />
		</ng-container>
		<!--fotoğraf alanı-->
		
		<!--border-->
		<ng-container>
			<ng-container>
				<div  *ngIf="isVisible">
					<div *ngFor="let summary of labelSummaries.value| keyvalue; let i = index">
						<div *ngFor="let border of resp.predict_results">
							<div *ngIf="checkSummaryAndTagname(summary.key, border.tagname) === true">
								<div class="product-border" [ngClass]="border.isSelected ? getBorderColorClass(i) : 'border-decline'" [ngStyle]="getBorderStyle(border)" (click)="toggleSelection(border)">
									<label [ngClass]="border.isSelected ? getLabelColorClass(i) : 'label-decline'"
										>{{ border.tagname.split(" ") }}
										<span class="tooltip-text">{{ border.tagname }}-{{ border.probability }}</span>
									</label>
								</div>
							</div>
						</div>
					</div>
				</div>
			</ng-container>
		</ng-container>
		<!--border-->
	</div>
	
	<div class="row">
		<div class="col-12">
			<ng-container>
				<!-- Bu kısımda görsel üzerindeki borderlara ait bilgiler tablo halinde yer alacak -->
				<table class="table table-bordered mt-3">
					<thead>
						<tr>
							<th>Label</th>
							<th>Ürün Miktarı</th>
							<th>Toplam Ürün Miktarına Oranı</th>
						</tr>
					</thead>
					<tbody *ngFor="let summary of labelSummaries.value | keyvalue">
						<tr>
							<td>{{ summary.key }}</td>
							<td>{{ summary.value }}</td>
							<td>% {{ calcPercentage(summary.value) }}</td>
						</tr>
					</tbody>
				</table>
			</ng-container>
		</div>
		<div class="col-12">
			<ng-container>
				<!-- Bu kısımda görsel üzerindeki borderları görselin yanında labelSummary başlığına göre liste liste gösteriyoruz -->
				<div class="row">
					<div class="col-12 mt-4">
						<div class="row">
							<!-- Bu kısımda aynı listedeki mantık gibi sayfanın 25% kullanarak en son hepsini seç checkbox'ını yerleştiriyoruz -->
							<div class="col-6">
								<div class="form-check">
									<input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" [(ngModel)]="isChecked" (change)="setAllSelected(resp.predict_results)" />
									<label class="form-check-label" for="flexCheckDefault"> Hepsini Seç </label>
								</div>
							</div>
							<div class="col-3">
								
								<button type="button" class="btn btn-success btn-sm" (click)="changeBorderVisible()">
									<span>Gizle / Görüntüle</span>
								</button>
							</div>
							<div class="col-3">
								<!-- <input type="checkbox" [(ngModel)]="isChecked" (change)="setAllSelected(resp.predict_results)" /><b>Hepsini Seç</b> -->
								<button type="button" class="btn btn-success btn-sm" (click)="sendApprovedBorder()" [disabled]="(isFormSending | async) == true">
									<span *ngIf="(isFormSending | async) == true">Kaydediliyor...</span>
									<span *ngIf="(isFormSending | async) == false">Formu Gönder</span>
								</button>
							</div>
						</div>
					</div>
					<div class="col-12 mt-4">
						<div class="row">
							<div class="col-auto" *ngFor="let summary of labelSummaries.value | keyvalue">
								<label
									><b>{{ summary.key }} : {{ summary.value }}</b></label
								>

								<div class="checkboxes" *ngFor="let border of resp.predict_results">
									<div *ngIf="checkSummaryAndTagname(summary.key, border.tagname) === true">
										<input type="checkbox" [(ngModel)]="border.isSelected" />
										{{ border.tagname }}-{{ border.probability }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</ng-container>
		</div>
	</div>
</div>
